var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-btn",
        {
          staticClass: "mb-2",
          attrs: {
            tertiary: "",
            small: "",
            to: _vm.backPath
          }
        },
        [
          _c(
            "v-icon",
            {
              attrs: {
                small: "",
                left: ""
              }
            },
            [_vm._v("mdi-arrow-left")]
          ),
          _vm._v("All filters ")
        ],
        1
      ),
      _vm.form.open
        ? _c("create-filter", {
            attrs: {
              cancelable: "",
              editing: _vm.form.editing
            },
            on: {
              stored: _vm.closeForm,
              cancel: _vm.closeForm
            }
          })
        : _c(
            "gg-card",
            [
              _c("gg-card-header", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center flex-wrap"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "mr-auto"
                      },
                      [_vm._v("Current Filters")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            return _vm.openForm(false)
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Create Filter ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "gg-card-text",
                [
                  _c("filter-table", {
                    on: {
                      edit: function edit($event) {
                        return _vm.openForm(true)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }